import Keycloak from 'keycloak-js'

// Configuration: adapt to your Keycloak setup
const keycloak = new Keycloak({
  // Keycloak PROD (2026-10-07) : auth.v3.preprod.wheere.tech n'existe plus. Acces reserve au role
  // PLATFORM_ADMIN (verifie par le backend, server/admin-role.js).
  url: 'https://auth.wheere.com',
  realm: 'wheere',
  clientId: 'mqtt-redirection-admin',
})

export default keycloak
